import { render } from "./FilterMessageType.vue?vue&type=template&id=04390f98"
import script from "./FilterMessageType.vue?vue&type=script&lang=js"
export * from "./FilterMessageType.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__